import type { SiteNavItem } from '../types';
import { DEFAULT_ORIGINAL_CONFIG } from '../admin/adminSiteConfigData';

/** Combina itens do banco com defaults para não faltar links essenciais no menu. */
export function resolveNavbarMenuItems(configItems?: SiteNavItem[]): SiteNavItem[] | undefined {
    const defaults = DEFAULT_ORIGINAL_CONFIG.navbar?.menuItems ?? [];
    if (!configItems?.length) return defaults.length ? defaults : undefined;

    const merged = new Map<string, SiteNavItem>();
    for (const item of defaults) merged.set(item.id, { ...item });
    for (const item of configItems) merged.set(item.id, { ...merged.get(item.id), ...item });

    const items = Array.from(merged.values())
        .filter(i => i.visible !== false)
        .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

    return items.length ? items : undefined;
}
